import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';

import './apply-now.component.scss';

import * as _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap-datepicker';

export class ApplyNow extends Base {
	form: HTMLFormElement;
	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element;

	pagerHomeButtonContainer: Element;
	pagerHomeButton: Element;

	pagerHomePage: Element;
	pagerPages: Element[];
	pagePageToggles: Element[];

	applyForm: HTMLFormElement;
	applyFormSubmit: Element[];
	applyFormRadio: Element[];
	formDatePicker: Element;
	formTimePicker: Element;
	_startDate: Date;

	publicHolidays: any[];

	constructor(element: Element) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.modals = Array.from(this.element.querySelectorAll('.js-apply-now-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-apply-now-modal-open'));
		this.closeButton = this.element.querySelector('.js-apply-now-modal-close');

		this.pagerHomeButtonContainer = this.element.querySelector('.js-pager-home-button-container');
		this.pagerHomeButton = this.element.querySelector('.js-pager-back-button');

		this.pagerHomePage = this.element.querySelector('.js-pager-page-home');
		this.pagerPages = Array.from(this.element.querySelectorAll('.js-pager-page'));
		this.pagePageToggles = Array.from(this.element.querySelectorAll('.js-pager-page-toggle'));

		this.applyForm = this.element.querySelector('form') as HTMLFormElement;
		this.applyFormSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.applyFormRadio = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
		this.publicHolidays = ['2018/01/01', '2018/03/21', '2018/03/30', '2018/04/02', '2018/04/27', '2018/05/01', '2018/06/16', '2018/08/09', '2018/09/24', '2018/12/16', '2018/12/17', '2018/12/25', '2018/12/26'];

		// DATE PICKER
		$(document).ready(function () {
			$('input.js-date-picker').datepicker({
				todayHighlight: true,
				format: 'yyyy/mm/dd',
				daysOfWeekDisabled: [0, 6],
				enableOnReadonly: true,
				autoclose: true
			}).on('changeDate', function (event) {
				let _event;
				if (typeof window.event === 'function') {
					_event = new Event('change');
					this.dispatchEvent(_event);
				} else {
					_event = document.createEvent('HTMLEvents');
					_event.initEvent('change', false, false);
					this.dispatchEvent(_event);
				}
			});
		});
		TooltipsService.initTooltips();
	}

	bindEvents() {
		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.closeButton.addEventListener('click', (event) => this.closeModal());

		// this.modalLinks.map((item) => item.addEventListener('click', (event) => {
		// 	this.openModals(event);
		// }));

		// Changed the way this works for dynamic content - Malcolm 14-02-2018
		document.addEventListener('click', (e: any) => {
			const composedPath = (el) => {
				const path = [];
				while (el) {
					path.push(el);
					if (el.tagName === 'HTML') {
						path.push(document);
						path.push(window);
						return path;
					}
					el = el.parentElement;
				}
			};

			const path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
			const hasClass = (cls: string) => {
				return _.filter(path, (p) => {
					let exists = false;
					_.each(p.classList, (cl) => {
						if (cl === cls) {
							exists = true;
						}
					});
					if (p.classList && exists) {
						return p;
					}
				})[0];
			};
			if (hasClass('js-apply-now-modal-open')) {
				this.openModals(e);
			}
		}, false);

		this.pagePageToggles.map((item) => item.addEventListener('click', (event) => {
			this.togglePages(event);
		}));

		if (this.pagerHomeButton) {
			this.pagerHomeButton.addEventListener('click', () => this.showHomePage());
		}

		this.applyFormRadio.map((item) => item.addEventListener('click', (event) => {
			const evt: any = event.target;
			const identificationField: any = this.applyForm.querySelector('input[name=identification]');
			const identificationType: any = evt.value;

			if (identificationType === 'said') {
				identificationField.classList.remove('form__input--identification--passport');
				identificationField.classList.add('form__input--identification');
				identificationField.placeholder = 'Enter you South Africa ID number';
				identificationField.type = 'number';
			} else {
				identificationField.classList.remove('form__input--identification');
				identificationField.classList.add('form__input--identification--passport');
				identificationField.placeholder = 'Enter you Passport number';
				identificationField.type = 'text';
			}
		}));
		this.applyFormSubmit.map((item) => item.addEventListener('click', (event) => {
			const _button = event.target as HTMLFormElement;
			const _form = _button.closest('form') as HTMLFormElement;
			const formFields: any = _form.querySelectorAll('input, select');
			this.validationService.validate(formFields);
			const valid = Array.from(_form.querySelectorAll('.form__group--error'));
			if (valid.length === 0) {
				this.formsService.detect(this.applyForm, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));
	}

	isClickOutsideModal(event) {
		if (event.target === this.activeModal) {
			this.closeModal();
		}
	}

	openModals(event) {
		const element: Element = event.target;
		let modalId = element.getAttribute('data-modal');
		if (!modalId) {
			const parentElement = $(element).closest('.js-apply-now-modal-open');
			modalId = parentElement.attr('data-modal');
		}

		this.activeModal = this.getModalById(modalId);
		this.openModal();
	}

	closeModal() {
		this.analyticsService.dtmFormAbandon();
		this.activeModal.classList.add('modal--close');

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);
	}

	openModal() {
		this.formDatePicker = this.activeModal.querySelector('.js-date-picker');
		this.formTimePicker = this.activeModal.querySelector('.js-time-picker');
		if (this.formDatePicker) {
			this.formDatePicker.addEventListener('change', (event) => {
				this.validateDate(event.target);
			});
		}
		this.resetForm();
		this.populateDatePicker();
		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');
	}

	getModalById(id) {
		return document.querySelector(`#${id}`);
	}

	togglePages(event) {
		this.pagerHomePage.classList.add('apply-now__page--hidden');
		this.pagerHomeButtonContainer.classList.add('apply-now__home-button-container--visible');
		this.hidePages();
		const goToPage = event.currentTarget.getAttribute('data-target');
		this.element.querySelector(`#${goToPage}`).classList.remove('apply-now__page--hidden');
	}

	hidePages() {
		for (let i = 0; i < this.pagerPages.length; i++) {
			this.pagerPages[i].classList.add('apply-now__page--hidden');
		}
	}

	showHomePage() {
		this.hidePages();
		this.pagerHomePage.classList.remove('apply-now__page--hidden');
		this.pagerHomeButtonContainer.classList.remove('apply-now__home-button-container--visible');
	}

	resetForm() {
		if (this.applyForm) {
			this.applyForm.reset();
			const formContainerLoader = this.element.querySelector('.form__loader--container');
			const formContainerFields = this.element.querySelector('.form__fields--container');
			const formContainerThankyou = this.element.querySelector('.form__thankyou--container');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	populateDatePicker() {
		if (this.formDatePicker) {
			this._startDate = this.validateDate();
			$(this.formDatePicker).datepicker('setStartDate', this._startDate).datepicker('setDatesDisabled', this.publicHolidays);
		}
	}

	validateDate(_setDate: any = '') {
		let _enabledOptions = false;
		const _currentDateTime = new Date();
		let _currentHour = _currentDateTime.getHours();
		let _currentMin = _currentDateTime.getMinutes();

		if (_setDate !== '') {
			const _selectedDate = new Date(_setDate.value);
			const _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
			const _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();

			_currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());

			if (_tmpSelectedDate !== _tmpCurrentDate) {
				_currentHour = 7;
				_currentMin = 0;
				_enabledOptions = true;
			} else {
				_enabledOptions = false;
			}
		}

		if (_currentHour >= 16) {
			_currentDateTime.setDate(_currentDateTime.getDate() + 1)
			_currentHour = 7;
			_currentMin = 0;
		}

		if ((_currentMin >= 30) && (_currentHour <= 15)) {
			_currentHour++;
		} else if ((_currentMin >= 30) && (_currentHour >= 15)) {
			_currentDateTime.setDate(_currentDateTime.getDate() + 1)
			_currentHour = 7;
		}

		const _currentDayBefore = _currentDateTime.getDay();

		if (_currentDayBefore === 0) {
			_currentDateTime.setDate(_currentDateTime.getDate() + 1)
		} else if (_currentDayBefore === 6) {
			_currentDateTime.setDate(_currentDateTime.getDate() + 2)
		}

		let _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
		if (this.publicHolidays) {
			this.publicHolidays.forEach(holiday => {
				if (_currentDate === holiday) {
					_currentDateTime.setDate(_currentDateTime.getDate() + 1);

					const _currentDay = _currentDateTime.getDay();

					if (_currentDay === 0) {
						_currentDateTime.setDate(_currentDateTime.getDate() + 1);
					} else if (_currentDay === 6) {
						_currentDateTime.setDate(_currentDateTime.getDate() + 2);
					}

					_currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
					_currentHour = 7;
					_currentMin = 0;
				}
			});
		}

		const _currentDayAfter = _currentDateTime.getDay();

		if (_currentDayAfter === 0) {
			_currentDateTime.setDate(_currentDateTime.getDate() + 1)
		} else if (_currentDayAfter === 6) {
			_currentDateTime.setDate(_currentDateTime.getDate() + 2)
		}

		const item = <HTMLSelectElement>this.formTimePicker;
		const _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
		for (let i = item.options.length - 1; i >= 0; i--) {
			if (item.options[i].value !== 'Anytime') {
				if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
					item.options[i].disabled = true;
				} else if (_enabledOptions === true) {
					item.options[i].disabled = false;
				}
			}
		}

		return _currentDateTime;
	}
}



// WEBPACK FOOTER //
// ./components/apply-now/apply-now.component.ts